import React from "react";
import { useTranslation } from "react-i18next";
import "./download.css";

const Download = () => {
  const { t } = useTranslation();

  return (
    <>
      <section className="download top" style={{ display: "flex", flexWrap: "wrap" }}>
        <div className="container flex_space" >
          <div className="row" >
            <h3>{t("header")}</h3>
            <h1>{t("delights")}</h1>
            <ul>
              <li>
                <b>{t("khachapuri")}</b> {t("khachapuriDesc")}
              </li>
              <li>
                <b>{t("khinkali")}</b> {t("khinkaliDesc")}
              </li>
              <li>
                <b>{t("kubdari")}</b> {t("kubdariDesc")}
              </li>
              <li>
                <b>{t("satsivi")}</b> {t("satsiviDesc")}
              </li>
              <li>
                <b>{t("chakhokhbili")}</b> {t("chakhokhbiliDesc")}
              </li>
            </ul>
          </div>
          <div className="row row2">
            <img src="/images/food.jpg" alt="" className="image" />
          </div>
        </div>
      </section>

    </>
  );
};

export default Download;
